import { render, staticRenderFns } from "./PCarousel.vue?vue&type=template&id=2b905df0&scoped=true"
import script from "./PCarousel.vue?vue&type=script&lang=js"
export * from "./PCarousel.vue?vue&type=script&lang=js"
import style0 from "./PCarousel.vue?vue&type=style&index=0&id=2b905df0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b905df0",
  null
  
)

export default component.exports